module.exports = __webpack_public_path__ + "img/Storage.13406912.svg";